export enum JackpotTabEnum {
  MyJackpots = 'MyJackpots',
  AllJackpots = 'AllJackpots',
  PartnersJackpot = 'Partners',
  TopPlayers = 'TopPlayers',
  PlatinumJackpot = 'Platinum',
}
